import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, makeObservable } from 'mobx'

import classNames from 'classnames'

import { COURSE_CONTENT_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'
import { getTimeLeftObject } from '@elo-kit/utils/dateTime.utils'

const CountdownCol = ({ alwaysShow, plural, singular, value, showSeparator = true }) => {
  if (value > 0 || alwaysShow) {
    return (
      <span className='Countdown-col'>
        <span className='Countdown-col-element'>
          <strong>{value || 0}</strong>
          <span>
            {value === 1 ? singular : plural}
            {showSeparator && ','}
          </span>
        </span>
      </span>
    )
  }

  return null
}

@observer
class Countdown extends Component {
  @observable countDown = {}

  constructor(props) {
    super(props)
    makeObservable(this)
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const date = getTimeLeftObject(this.props.date)
      if (date) {
        this.countDown = date
      } else {
        this.props.refreshCountdown()
        this.stop()
      }
    }, 1000)
  }

  componentWillUnmount() {
    this.stop()
  }

  stop() {
    clearInterval(this.interval)
  }

  render() {
    const { days, hours, minutes, seconds, weeks } = this.countDown

    const isTimeLessThanDay = weeks === 0 && days === 0

    return (
      <div className={classNames(COURSE_CONTENT_CLASS_NAMES.countdownContainerClassName, 'Countdown')}>
        <CountdownCol
          plural={I18n.t('react.payer.lesson.weeks')}
          singular={I18n.t('react.payer.lesson.week')}
          value={weeks}
        />
        <CountdownCol
          plural={I18n.t('react.payer.lesson.days')}
          singular={I18n.t('react.payer.lesson.day')}
          value={days}
          showSeparator={isTimeLessThanDay}
        />
        {isTimeLessThanDay && (
          <>
            <CountdownCol
              plural={I18n.t('react.payer.lesson.short_hours')}
              singular={I18n.t('react.payer.lesson.short_hours')}
              value={hours}
            />
            <CountdownCol
              plural={I18n.t('react.payer.lesson.short_mins')}
              singular={I18n.t('react.payer.lesson.short_mins')}
              value={minutes}
            />
            <CountdownCol
              alwaysShow
              plural={I18n.t('react.payer.lesson.short_secs')}
              singular={I18n.t('react.payer.lesson.short_secs')}
              value={seconds}
              showSeparator={false}
            />
          </>
        )}
      </div>
    )
  }
}

Countdown.displayName = 'Countdown'

export default Countdown
